<div class="banner">

    <div class="mariam">
    <img src="./assets/mariam_circle.png" alt="mariam"/>
    </div>

    <div class="churchname">
    <p class="amharicname">ደብረ ብስራት ቅዱስ ገብርኤል ገዳም የኢትዮጵያ.ኦ.ተ.ቤ/ክርስቲያን</p>
    <p class="englishname">SAINT GABRIEL MONASTERY E.O.T.C</p>
    <a class="donate-here" routerLink="/donate" >DONATE</a>
    </div>

    <div class="meskel">
    <img src="../assets/meskel.png" alt=meskel/>
    </div>

</div>
